import classNames from "classnames";
import { useEffect, useState } from "react";

import { Icon } from "src/app/components/icon/Icon";
import ConfirmTargetGroupForm from "src/app/modules/auth/components/ConfirmTargetGroup";
import ForgottenPasswordForm from "src/app/modules/auth/components/ForgottenPassword";
import LoginForm from "src/app/modules/auth/components/Login";
import RegisterForm from "src/app/modules/auth/components/Register";
import { FORM_TYPES } from "src/app/modules/auth/constants";
import { IAuth } from "src/types/global";

import authCSS from "./Auth.module.css";

const AuthModal = ({
  isModalOpen,
  hideAuthModal,
  formType,
  onRegistration,
  onAuthorization,
  onResetPassword,
  onConfirmTargetGroup,
  userData,
}: {
  isModalOpen: boolean;
  hideAuthModal: () => void;
  formType: string;
  onRegistration: (success: boolean) => void;
  onAuthorization: (success: boolean) => void;
  onResetPassword: (success: boolean) => void;
  onConfirmTargetGroup: (success: boolean) => void;
  userData: IAuth | undefined | null;
}) => {
  const [formToDisplay, setFormToDisplay] = useState(formType);
  const [modalOpen, setModalOpen] = useState(false);
  const changeForm = (formToDisplay = FORM_TYPES.LOGIN) => {
    setFormToDisplay(formToDisplay);
  };

  useEffect(() => {
    if (isModalOpen && formType) {
      setFormToDisplay(formType);
      setModalOpen(true);
    } else if (!isModalOpen && !formType) {
      setModalOpen(false);
    }
  }, [formType, isModalOpen]);
  return (
    <div className={classNames("u-pos-fixed", "u-z-index10", "u-w100", "u-h100 ", "u-bg-black", "u-bg-black-light", authCSS.modal, modalOpen ? "" : "u-none")}>
      {formToDisplay === FORM_TYPES.REGISTER && (
        <div className={classNames(authCSS.modalContentReg)}>
          <span className={classNames("u-t-primary", "u-cursor-pointer", "u-flex", "u-flex-content-end", authCSS.close)} onClick={hideAuthModal}>
            <Icon name={"close-modal"} className={authCSS.closeModal} />
          </span>
          <RegisterForm changeForm={changeForm} onRegistration={onRegistration} />
        </div>
      )}
      {formToDisplay === FORM_TYPES.CONFIRM_TARGET_GROUP && (
        <div className={classNames(authCSS.modalContentConfirm)}>
          <ConfirmTargetGroupForm userData={userData} onConfirmTargetGroup={onConfirmTargetGroup} />
        </div>
      )}
      {formToDisplay === FORM_TYPES.LOGIN && (
        <div className={classNames(authCSS.modalContentLog)}>
          <span className={classNames("u-t-primary", "u-cursor-pointer", "u-flex", "u-flex-content-end", authCSS.close)} onClick={hideAuthModal}>
            <Icon name={"close-modal"} className={authCSS.closeModal} />
          </span>
          <LoginForm changeForm={changeForm} onAuthorization={onAuthorization} />
        </div>
      )}
      {formToDisplay === FORM_TYPES.FORGOTTEN_PASSWORD && (
        <div className={classNames(authCSS.modalContentPass)}>
          <span className={classNames("u-t-primary", "u-cursor-pointer", "u-flex", "u-flex-content-end", authCSS.close)} onClick={hideAuthModal}>
            <Icon name={"close-modal"} className={authCSS.closeModal} />
          </span>
          <ForgottenPasswordForm changeForm={changeForm} onResetPassword={onResetPassword} />
        </div>
      )}
    </div>
  );
};

export default AuthModal;
